import React, { useEffect, useState } from "react";
import { getProperties, getUrl } from "aws-amplify/storage";
import { Image} from 'react-bootstrap';
// import { DEFAULT_USER_IMAGE } from "../../config";
import { S3_BUCKET , DEFAULT_USER_IMAGE } from "../../config";
import { AgendaPost, AgendaUser } from "../../graphql/API";
// import DEFAULT_USER_IMAGE from "../../assets/images/no-avatar.jpg";
// import { CacheManager, CachedImage } from '@georstat/react-native-image-cache';

interface IUserImage {
    comId: any;
    // image?: string;
    // avatarStyle?: any;
    customClass?: string;
    name?: string;
    onlyImage?: boolean;
};

const CompanyLogo = ({comId, customClass, name, onlyImage}: IUserImage) => {
    // console.log('STYLE', user.image);
    // const [cacheSize, setCacheSize] = useState<number | null>(null);
    // const [isCached, setIsCached] = useState<boolean | null>(null);
    const [imageUri, setImageUri] = useState<string>(null);//(S3_BUCKET + `${comId}/logo/logo.jpg`); //('');

    useEffect(() => {
        if (comId) {
            getImageUrl();
        }
    }, [comId]);

    const getImageUrl = async () => {
        const imageKey = `public/${comId}/logo/logo.jpg`;
    
        try {
            // Étape 1 : Vérifier l'existence de l'objet en tentant de récupérer ses propriétés.
            // Cette opération échoue (lance une erreur) si l'objet n'existe pas.
            await getProperties({ path: imageKey });
            const cacheBuster = `?v=${Date.now()}`;

            // Étape 2 : Si la ligne ci-dessus réussit, l'image existe. On peut obtenir l'URL.
            const response = await getUrl({ path: imageKey });
            
            // Construction de l'URI complète et décodée
            const origin = response.url.origin;
            const path = response.url.pathname.split('%20').join(' '); // Décodage simple des espaces
            const uri = origin + path + cacheBuster;
            
            // Définit l'URI pour l'image réelle
            setImageUri(uri);
            // console.log('URI de l\'image de la compagnie trouvée:', uri);

        } catch (error) {
            // Étape 3 : L'objet n'existe pas ou il y a une autre erreur (permission, etc.).
            console.warn(`Impossible de trouver ou d'accéder à l'image ${imageKey}. Affichage de l'alternative.`, error);

            // Définir l'état à null ou à l'URL de votre image par défaut (alternative)
            setImageUri(null); // 👈 C'est ici que vous définissez l'absence d'image
        }
    };
 
    return (
        // <Image source={{uri: imageUri || DEFAULT_USER_IMAGE}} style={avatarStyle} />
        <>
        {imageUri ?
            name ?
                onlyImage ?
                    <Image src={imageUri} className={customClass} alt={name} style={{}}/>
                :
                    <>
                        <Image src={imageUri} className={customClass} alt={name} />
                        {name}
                    </>
            :
                <Image src={imageUri} className={customClass} alt="Company name" />
        :
            name ?
                <>
                   {/* <span dangerouslySetInnerHTML={{ __html: name }} /> */}
                   {/* <span className="dashboard_row_link text-secondary fw-bold">{name}</span> */}
                   {name}
                </>  
            :
                <Image src={DEFAULT_USER_IMAGE} alt="Company name" className={customClass} />
        }
        </>
    );
};

export default CompanyLogo;